module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-infiniti.bc14dd33.png";